import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");

if (!container) {
  // index.html dagi `<div id="root">` o'chirilsa — darhol ko'rinadigan xato bo'lsin.
  throw new Error("#root elementi topilmadi (index.html)");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
